<app-page-panel 
    class="flex-fit" 
    iconNameFontAwesome="star" 
    pageTitle="Wirtschaftsplan"
    [showBackButton]="false" 
    [showBackColor]="true" 
    [showDetailsButton]="false" 
    [showSidepanelButton]="false" 
    [showCloseButton]="true"
    [showContent]="false" 
    (closeButtonClicked)="CloseButtonClick()">
</app-page-panel>
<form #wipForm="ngForm">
    <mat-dialog-content class="form-content">
        <div class="flex flex-col flex-stretch-self">
            <div class="flex flex-row flex-stretch-self flex-gap-120">
                <div class="flex flex-col flex-fill">
                    <mat-form-field>
                        <mat-label>Verwaltungsbereich</mat-label>
                        <mat-select [(ngModel)]="dataForm.verwaltungsbereichId"
                            name="verwaltung" required>
                            @for (item of dataWip.verwaltungsbereiche; track item) {
                                <mat-option [value]="item.id">{{item.name}}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field>
                        <mat-label>Plangebiet</mat-label>
                        <mat-select [(ngModel)]="dataForm.plangebietId"
                            name="plangebiet" required>
                            @for (item of dataWip.plangebiete; track item) {
                            <mat-option [value]="item.id">{{item.name}} ({{item.kurz}})</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field>
                        <mat-label>Gremium</mat-label>
                        <mat-select [(ngModel)]="dataForm.gremiumId"
                            name="gremium" required>
                            @for (item of dataGremien(); track item) {
                            <mat-option [value]="item.id">{{item.name}}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field>
                        <mat-label>Wirtschaftsplan</mat-label>
                        <mat-select [(ngModel)]="dataForm.wirtschaftsplanId"
                            name="wirtschaftsplan" required>
                            @for (item of dataWirtschaftsplaene(); track item) {
                            <mat-option [value]="item.id">{{item.wip}}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                    <app-element-panel 
                        class="form-panel" 
                        iconNameFontAwesome="euro_symbol"
                        pageTitle="Abschläge"
                        [showDetailsButton]="false">
                        <div class="flex flex-row flex-stretch-self flex-gap-24">
                            @if (isBNKVisible()) {
                                <div class="flex flex-col flex-fill">                       
                                    <div class="flex flex-row flex-fill flex-gap-12">
                                        <mat-form-field class="flex-fill form-field-remove-hint">
                                            <mat-label>BNK1-4 {{labelYearPlus1()}} (%)</mat-label>
                                            <input matInput required [(ngModel)]="dataWip.wirtschaftsplanerstellung.abschlagBNK14" name="AbschlagBNK14" type="number" min="0" max="100">
                                        </mat-form-field>
                                        <mat-form-field class="flex-fill form-field-remove-hint">
                                            <mat-label>BNK5-9 und BK (EV) {{labelYearPlus1()}} (%)</mat-label>
                                            <input matInput required [(ngModel)]="dataWip.wirtschaftsplanerstellung.abschlagBNK59" name="AbschlagBNK59" type="number" min="0" max="100">
                                        </mat-form-field>                                      
                                    </div>
                                </div>
                            }
                            @if (isJahr1Visible() || isJahr23Visible()) {
                                <div class="flex flex-col flex-fill">                       
                                    <div class="flex flex-row flex-fill flex-gap-12">
                                        <mat-form-field class="flex-fill form-field-remove-hint" *ngIf="isJahr1Visible()">
                                            <mat-label>Alle Kostengruppen {{labelYearPlus1()}} (%)</mat-label>
                                            <input  matInput required [(ngModel)]="dataWip.wirtschaftsplanerstellung.abschlagJahr1 " name="AbschlagJahr1" type="number" min="0" max="100">
                                        </mat-form-field>
                                        <mat-form-field class="flex-fill form-field-remove-hint" *ngIf="isJahr23Visible()">
                                            <mat-label>Alle Kostengruppen {{labelYearPlus2()}} (%)</mat-label>
                                            <input matInput required [(ngModel)]="dataWip.wirtschaftsplanerstellung.abschlagJahr2" name="AbschlagJahr2" type="number" min="0" max="100">
                                        </mat-form-field>
                                        <mat-form-field class="flex-fill form-field-remove-hint" *ngIf="isJahr23Visible()">
                                            <mat-label>Alle Kostengruppen {{labelYearPlus3()}}</mat-label>
                                            <input matInput required [(ngModel)]="dataWip.wirtschaftsplanerstellung.abschlagJahr3" name="AbschlagJahr3" type="number" min="0" max="100">
                                        </mat-form-field>                                      
                                    </div>
                                </div>
                            }
                            </div>
                    </app-element-panel>
                </div>
            </div>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions class="flex-justify">
        <button (click)="DeleteButtonClicked()" [disabled]="!wipForm.form.valid || isDataProgressing()" mat-button>WIP löschen</button>
        <div>
            <button (click)="SaveButtonClicked()" [disabled]="!wipForm.form.valid || isDataProgressing()" mat-button>WIP erstellen</button>
            <button mat-button mat-dialog-close>Abbrechen</button>
        </div>        
    </mat-dialog-actions>
</form>
